import { render } from "./LoginLogoutButton.vue?vue&type=template&id=47802464&ts=true"
import script from "./LoginLogoutButton.vue?vue&type=script&lang=ts"
export * from "./LoginLogoutButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__